"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var stylis_1 = require("stylis");
function webPReplace(element, _index, _children, _callback) {
    if (element.type === stylis_1.DECLARATION) {
        element.value = element.value.replace(/url\((.*)(?:\.png|\.jpg)("|'?)\)/g, 'url($1.webp$2)');
    }
}
exports.default = webPReplace;
